<template>
    <header v-if="isShowHeader" :class="theme">
        <div class="icon-group">
            <i v-if="showBack" class="fsfont back" @click="goCallback">&#xe609;</i>
            <i v-if="showCloseIcon" class="fsfont close" @click="handleClose">&#xe60d;</i>
            <i v-if="showShareIcon" class="fsfont share" @click="handleShare">&#xe62d;</i>
        </div>
        <div :class="['title', { 'line-elipsis': !isLongTitle, 'long-title': isLongTitle }]">{{ title }}</div>
    </header>
</template>
<script>
import JSBridge from '@fs/jsbridge/dist/lib/jsBridge.js'
import { isDeviceMobile, isHLApp } from '../utils'

export default {
    props: {
        title: {
            type: String,
            default: function () {
                return this.$t('fxhlkh')
            },
        },
        showBack: {
            type: Boolean,
            default: () => {
                return true
            },
        },
        showClose: {
            type: Boolean,
            default: false,
        },
        showShare: {
            type: Boolean,
            default: false,
        },
        shareParams: {
            type: Object,
            default: () => {
                return {
                    pageUrl: '',
                    title: '',
                    desc: '',
                    imageData: '',
                }
            },
        },
        isShowHeader: {
            type: Boolean,
            default: process.env.NODE_ENV == 'development',
        },
        theme: {
            type: String,
            default: 'dark',
        },
        backClose: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {}
    },
    mounted() {
        // const { NODE_ENV } = process.env
    },
    computed: {
        showCloseIcon() {
            return this.showClose && (!isDeviceMobile() || isHLApp())
        },
        showShareIcon() {
            return this.showShare
            // return this.showShare && (!isDeviceMobile() || isHLApp())
        },
        isLongTitle() {
            // 检查标题是否过长，如果是合规相关标题则认为是长标题
            return this.title && (this.title.length > 8 || this.title.includes('复星国际证券客户资料复核'))
        },
    },
    methods: {
        // 路由返回
        goCallback() {
            if (this.backClose) {
                this.$emit('backClose')
                return
            }
            if (history.length > 0) {
                this.$router.back()
            } else {
                this.$router.push({ name: 'account' })
            }
        },
        handleClose() {
            if (JSBridge) {
                JSBridge.close()
            } else {
                window.close()
            }
        },
        handleShare() {
            if (JSBridge) {
                // 仅在APP内有分享按钮
                JSBridge.share(this.shareParams)
            }
        },
    },
}
</script>
<style lang="less" scoped>
.light {
    color: white;
}

header {
    position: relative;
    left: -16px;
    display: flex;
    align-items: center;
    width: 100vw;
    height: 44px;
    color: #181818;
    font-size: 18px;
    line-height: 44px;
    text-align: center;

    .icon-group {
        display: flex;
        flex: 0 0 auto;
        align-items: center;

        i {
            min-width: 50px;

            &.back {
                font-size: 18px;
                transform: rotate(180deg);
            }

            &.close {
                font-size: 40px;
            }

            &.share {
                position: absolute;
                right: 0;
            }
        }
    }

    .title {
        position: absolute;
        left: 50%;
        max-width: 70%;
        font-weight: 600;
        transform: translateX(-50%);
        color: var(--fs-text-strong);
        &.long-title {
            max-width: 85%;
            font-size: 15px;
            white-space: nowrap;
            text-align: center;
            overflow: visible;
        }
    }
}
</style>
